<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Careers'"></navbar>
			<!--导航-->
			<!--banner-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/01顶部banner@2x.webp" class="bg" />
				<div class="msg_box">
					<div class="tit">CorDx Careers</div>
					<div class="txt">Now Seeking: Innovative People</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="txt"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					At CorDx, we’re driven by innovation. With nearly two decades of IVD experience, we’re a leader in IVD research and development, manufacturing, supply, and distribution. If you have a similar drive, a career at CorDx may be right for you. There’s no better place to begin—and continue—your career than right here.
				</div>
				<div class="txt"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
				>
					When you join the CorDx team, you’ll be at the forefront of an innovative global diagnostics model that rewards dedication, creativity, and science-focused solutions.
				</div>
				<div class="txt"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				>
					We’re transforming global diagnostics. Have what it takes to join us? Browse our career opportunities to begin.
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_2_el" style="background-color: #F9FAFE;">
					<div class="img_box">
						<img src="../../assets/img/careers_1.webp" />
					</div>
					<div class="tit">Comprehensive Health Care</div>
					<div class="txt">
						CorDx’s competitive benefits package includes medical, dental, and vision coverage for employees and their dependents.
					</div>
				</div>
				<div class="block_2_el" style="background-color: #FEFBF3;">
					<div class="img_box">
						<img src="../../assets/img/careers_2.webp" />
					</div>
					<div class="tit">Retirement Plans</div>
					<div class="txt">
						Your future is important to us. That’s why we sponsor generous retirement plans that are sure to set your mind at ease.
					</div>
				</div>
				<div class="block_2_el" style="background-color: #FBFEFC;">
					<div class="img_box">
						<img src="../../assets/img/careers_3.webp" />
					</div>
					<div class="tit">Professional Development</div>
					<div class="txt">
						CorDx is growing fast—and we want <br />you to grow, too. We encourage and provide support for our team members as they pursue new skills and improve existing ones.
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="left">
					<div class="cate_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Categories</div>
						<div class="list_box">
							<div v-for="(value, index) in cateOptions" :key="index" class="list_el" @click="cateHandle(value);">
								<div class="list_el_main">
									<div class="left">
										<img :src="value.is_checked == 1 ? require('@/assets/img/checked.png') : require('@/assets/img/no_check.png') " />
									</div>
									<div class="right">
										{{ value.catname }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="cate_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Location</div>
						<div class="list_box">
							<div v-for="(value, index) in locationOptions" :key="index" class="list_el" @click="locationHandle(value);">
								<div class="list_el_main">
									<div class="left">
										<img :src="value.is_checked == 1 ? require('@/assets/img/checked.png') : require('@/assets/img/no_check.png') " />
									</div>
									<div class="right">
										{{ value.catname }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="right">
					<div class="input_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<input v-model="searchVal" placeholder="Search for a job..." v-on:input="searchInput" />
						<div class="btn_box" @click="searchClick">
							<van-icon name="search" size="20px" color="#ffffff" style="position: relative;top: 3px;font-weight: bold;" />
						</div>
					</div>
					<div
						v-if="careersData.length > 0"
						v-loading="careersLoading"
						class="product_list"
					>
						<el-collapse v-for="(value, index) in careersData" accordion>
							<van-collapse v-model="activeNames" :border="false" @change="collChange">
								<van-collapse-item :name="value.id" :border="false">
									<template #title>
										<div class="title_box">
											<div class="tips_box">
												<div v-for="(value1, index1) in value.address_list" :key="index1" class="tips_el">{{ value1.catname }}</div>
											</div>
											<div class="tit">{{ value.title }}</div>
										</div>
									</template>
									<template #right-icon>
										<van-icon :name="isHas(value.id) ? 'clear' : 'add' " size="24px" color="#0B318F" />
									</template>
									<div class="content">
										<div class="content_main" v-html="value.content"></div>
										<div class="btn_box_more btn_box" @click="goApply(value)">
											Apply Now<img src="../../assets/img/组 32@2x.png" />
										</div>
									</div>
								</van-collapse-item>
							</van-collapse>
						</el-collapse>
					</div>
					<div v-else style="padding: 20px 0;color: #999999;text-align: center;">
						<!-- Sorry, but nothing matched your search terms. -->
						<img src="../../assets/img/search_no.png" />
					</div>
					<div v-if="careersData.length > 0" class="page_box">
						<el-pagination
							layout="prev, pager, next"
							:total="careersPage"
							:page-size="5"
							@current-change="careersPageChange"
						></el-pagination>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块8-->
			<div class="block_8"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_8_el" style="background-color: #F9FAFE;margin-right: 30px;" @click="goCulture(1)">
					<div class="img_box">
						<img src="../../assets/img/2023102701.webp" />
					</div>
					<div class="tit">Aiiso Truth Code</div>
				</div>
				<div class="block_8_el" style="background-color: #FBFEFC;" @click="goCulture(3)">
					<div class="img_box">
						<img src="../../assets/img/2023102703.webp" />
					</div>
					<div class="tit">Aiiso Work Code</div>
				</div>
				<div class="block_8_el" style="background-color: #FEFBF3;margin-left: 30px;" @click="goCulture(4)">
					<div class="img_box">
						<img src="../../assets/img/20251021.webp" />
					</div>
					<div class="tit">Aiiso Social Art</div>
				</div>
			</div>
			<!--块8-->
			<!--块4-->
			<div class="block_4"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_4_main">
					<div class="title">Recent News</div>
					<div class="block_4_box">
						<div
							v-for="(value, index) in newsData"
							:key="index"
							class="block_4_el"
							@mouseover="newsOver(value.id)"
							@mouseleave="newsLeave"
							@click="goResourcesInfo(value)"
						>
							<img :src="value.image" />
							<div class="msg_box">
								<div class="txt">{{ value.title }}</div>
							</div>
							<div class="time">{{ value.fabu_time }}</div>
							<div v-if="isShow == value.id" class="mask_box"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="mask_tit">{{ value.title }}</div>
								<div class="mask_txt">{{ value.description }}</div>
							</div>
						</div>
					</div>
					<div class="btn_box_more" style="position: absolute;left: 50%;transform: translate(-50%, 0px);" @click="goResources">
						View More<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块7-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import contact from '@/component/pc/contact.vue'  //联系我们
import { resourcesList, careersCate, careersLocation, careersList } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isShow: null,
			cateOptions: [],
			locationOptions: [],
			searchVal: '',
			activeNames: [],
			nowActived: [],
			newsData: [],  //新闻数据
			cateIds: [],
			locationsIds: [],
			careersData: [],
			careersPage: 0,
			noPage: 1,
			careersLoading: false,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Careers - CorDx';
		resourcesList({
			catid: 1,
			page: 1,
			page_size: 3,
			language: sessionStorage.getItem('lang'),
		}).then(res2 => {
			that.newsData = res2.data.data;
			that.isLoading = false;
		});
	},
	mounted() {
		let that = this;
		//请求岗位列表
		that.getCareersCate();
		//请求岗位地点
		that.getCareersLocation();
		//请求岗位列表
		that.getCareersList();
	},
	watch: {
		//
	},
	methods: {
		//跳转文化规章
		goCulture(value) {
			let that = this;
			switch(value) {
				case 1:
					let routeData1 = that.$router.resolve({ path: "/Culture/Aiiso_Truth_Code" });
					window.open(routeData1.href, '_blank');
				break;
				case 2:
					let routeData3 = that.$router.resolve({ path: "/culture/cn" });
					window.open(routeData3.href, '_blank');
				break;
				case 3:
					let routeData2 = that.$router.resolve({ path: "/Culture/Aiiso_Work_Code" });
					window.open(routeData2.href, '_blank');
				break;
				case 4:
					let routeData4 = that.$router.resolve({ path: "/Culture/Aiiso_Social_Art" });
					window.open(routeData4.href, '_blank');
				break;
			}
		},
		//岗位输入搜索
		searchInput() {
			let that = this;
			that.noPage = 1;
			that.getCareersList();
		},
		//点击搜索岗位
		searchClick() {
			let that = this;
			that.noPage = 1;
			that.getCareersList();
		},
		//请求岗位分类
		getCareersCate() {
			let that = this;
			careersCate({
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.cateOptions = res.data;
			});
		},
		//请求岗位地点
		getCareersLocation() {
			let that = this;
			careersLocation({
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.locationOptions = res.data;
			});
		},
		//岗位分类点击
		cateHandle(val) {
			let that = this;
			let dataArray = that.cateOptions;
			that.cateIds = [];
			dataArray.forEach((value, index) => {
				if(value.id == val.id) {
					if(value.is_checked == 0) {
						dataArray[index].is_checked = 1;
					}else {
						dataArray[index].is_checked = 0;
					}
				}
			});
			that.cateOptions = dataArray;
			that.cateOptions.forEach((value, index) => {
				if(value.is_checked == 1) {
					that.cateIds.push(value.id);
				}
			});
			that.noPage = 1;
			that.getCareersList();
		},
		//地点分类点击
		locationHandle(val) {
			let that = this;
			let dataArray = that.locationOptions;
			that.locationsIds = [];
			dataArray.forEach((value, index) => {
				if(value.id == val.id) {
					if(value.is_checked == 0) {
						dataArray[index].is_checked = 1;
					}else {
						dataArray[index].is_checked = 0;
					}
				}
			});
			that.locationOptions = dataArray;
			that.locationOptions.forEach((value, index) => {
				if(value.is_checked == 1) {
					that.locationsIds.push(value.id);
				}
			});
			that.noPage = 1;
			that.getCareersList();
		},
		//岗位列表分页
		careersPageChange(val) {
			let that = this;
			that.noPage = val;
			that.getCareersList();
		},
		//请求岗位列表
		getCareersList() {
			let that = this;
			that.careersLoading = true;
			careersList({
				cate_id: that.cateIds.join(','),
				address_id: that.locationsIds.join(','),
				page: that.noPage,
				keyword: that.searchVal,
				page_size: 5,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.careersData = res.data.data;
				that.careersPage = res.data.total;
				that.careersLoading = false;
			});
		},
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			// let { href } = that.$router.resolve({
			// 	path: '/resources-info',
			// 	query: {
			// 		id: value.unionid,
			// 	}
			// });
			// window.open(href, '_blank');
			let routeData = that.$router.resolve({name: "Resourcesinfo", params: { resourcesInfoId: value.custom } });
			window.open(routeData.href, '_blank');
		},
		//折叠面板点击
		collChange(activeNames) {
			let that = this;
			that.nowActived = activeNames;
		},
		isHas(id) {
			let that = this;
			if(that.nowActived.length > 0) {
				let str = null;
				that.nowActived.forEach((value, index) => {
					if(value == id) {
						str = 1;
					}
				});
				if(str == 1) {
					return true;
				}else {
					return false;
				}
			}else {
				return false;
			}
		},
		//新闻滑入
		newsOver(value) {
			let that = this;
			that.isShow = value;
		},
		//新闻滑出
		newsLeave() {
			let that = this;
			that.isShow = null;
		},
		goResources() {
			this.$router.push({ path: '/resources' });
		},
		goApply(value) {
			sessionStorage.setItem('careersName', value.title);
			this.$router.push({ path: '/careers-apply', });
		},
	}
}
</script>

<style scoped>
>>> .product_list ol,>>> .product_list ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
/* >>> .product_list h3 strong{
	font-size: 24px;
}
>>> .product_list h3 font{
	font-size: 24px;
}
>>> .product_list h5{
	font-size: 20px;
}
>>> .product_list h5 font{
	font-size: 20px;
}
>>> .product_list p{
	font-size: 18px;
}
>>> .product_list p font{
	font-size: 18px;
}
>>> .product_list li{
	font-size: 18px;
}
>>> .product_list li::before{
	content: '●';
	padding-right: 4px;
} */
>>> .product_list .van-collapse-item__content{
	color: #000000 !important;
	font-size: 16px !important;
	padding: 30px 0 40px 0;
	border-bottom: 1px solid #999999;
}
>>> .product_list .van-cell{
	padding: 20px 0 12px 0;
	font-size: 18px;
	color: #000000;
	border-bottom: 1px solid #999999;
}
>>> .product_list .el-collapse{
	border: none;
}
>>> .product_list .van-icon{
	top: 30px;
}
.product_list .content_main{
	padding-bottom: 30px;
}
>>> .product_list .title_box{
	cursor: pointer;
}
>>> .product_list .title_box .tit{
	padding-top: 12px;
	font-size: 26px;
}
>>> .product_list .title_box:hover{
	color: #0066D4;
}
>>> .product_list .title_box .tips_box .tips_el{
	display: inline-block;
	margin-right: 20px;
	padding: 8px 30px;
	border-radius: 22px;
	background-color: #EFEFEF;
	color: #0B318F;
	font-size: 14px;
}
</style>
<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块8*/
	.block_8{
		width: 1140px;
		margin: 0 auto;
		display: flex;
		padding-bottom: 100px;
		.block_8_el{
			flex: 1;
			margin: 0 0px;
			padding-bottom: 10px;
			cursor: pointer;
			.txt{
				padding: 0 30px;
				font-size: 18px;
				color: #706B69;
			}
			.tit{
				padding: 30px 30px 15px 30px;
				font-size: 35px;
				line-height: 1.2;
			}
			.img_box{
				overflow: hidden;
				img{
					width: 100%;
					transition: all 1s;
				}
			}
		}
		.block_8_el:hover{
			img{
				transform: scale(1.3);
			}
		}
	}
	/*块4*/
	.block_4{
		width: 100%;
		background-color: transparent;
		background-image: linear-gradient(180deg,  #F1ECE6 20%, #FFFFFF 100%);
		.block_4_main{
			width: 1140px;
			margin: 0 auto;
			padding: 100px 0 150px 0;
			.block_4_box{
				display: flex;
				padding: 60px 0 50px 0;
				.block_4_el{
					flex: 1;
					position: relative;
					margin: 0 20px;
					background-color: #ffffff;
					box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
					cursor: pointer;
					overflow: hidden;
					.mask_box{
						position: absolute;
						width: 100%;
						height: 100%;
						top: 0;
						background-color: #ffffff;
						padding: 34px;
						.mask_tit{
							font-size: 20px;
							color: #000000;
						}
						.mask_txt{
							padding-top: 40px;
							font-size: 16px;
							color: #706B69;
						}
					}
					.msg_box{
						width: 100%;
						padding: 30px 34px 120px 34px;
						border-top: 2px solid #0B318F;
						.txt{
							color: #000000;
							font-size: 22px;
						}
					}
					.time{
						position: absolute;
						z-index: 2;
						bottom: 40px;
						left: 34px;
						font-size: 18px;
						color: #706B69;
					}
					img{
						width: 100%;
						// height: auto;
						height: 227px;
						object-fit: cover;
					}
				}
			}
			.title{
				font-size: 45px;
				color: #000000;
			}
		}
	}
	/*块3*/
	.block_3{
		width: 1140px;
		display: flex;
		margin: 0 auto;
		padding: 80px 0 100px 0;
		.right{
			flex: 1;
			padding-left: 30px;
			.page_box{
				padding-top: 30px;
				text-align: center;
			}
			.input_box{
				padding-bottom: 4px;
				.btn_box{
					width: 7%;
					margin-left: 3%;
					padding: 4px 20px;
					border-radius: 18px;
					background-color: #0066D4;
					display: inline-block;
					cursor: pointer;
				}
				input{
					width: 90%;
					height: 45px;
					line-height: 45px;
					border: 1px solid #EFEFEF;
					background-color: #ffffff;
					text-indent: 20px;
					font-size: 18px;
					color: #0B318F;
				}
				input:focus{
					outline: none;
					border: 2px solid #0066D4;
				}
			}
		}
		.left{
			width: 285px;
			.cate_box{
				padding: 24px 26px;
				background-color: #EFEFEF;
				.search_box{
					padding: 10px 0 15px 0;
					input{
						width: 100%;
						height: 45px;
						line-height: 45px;
						background-color: #ffffff;
						color: #000000;
						padding-left: 20px;
						border: 1px solid #999999;
					}
				}
				.list_height{
					height: 300px;
					overflow-y: scroll;
				}
				.list_box{
					.list_el{
						padding: 10px 0;
						.list_el_child{
							padding: 10px 0 0 20px;
						}
						.list_el_main{
							font-size: 18px;
							cursor: pointer;
							display: flex;
							.right{
								flex: 1;
								padding-left: 8px;
								line-height: 1.2;
							}
							.left{
								width: 16px;
								img{
									width: 100%;
								}
							}
						}
					}
				}
				.tit{
					padding-bottom: 15px;
					font-size: 21px;
					font-weight: bold;
				}
			}
		}
	}
	/*块2*/
	.block_2{
		width: 1140px;
		margin: 0 auto;
		display: flex;
		.block_2_el{
			flex: 1;
			margin: 0 10px;
			padding-bottom: 40px;
			cursor: pointer;
			.txt{
				padding: 0 24px;
				font-size: 18px;
				color: #706B69;
			}
			.tit{
				padding: 20px 30px 10px 30px;
				font-size: 35px;
				line-height: 1.2;
			}
			.img_box{
				overflow: hidden;
				img{
					width: 100%;
					transition: all 1s;
				}
			}
		}
		.block_2_el:hover{
			img{
				transform: scale(1.3);
			}
		}
	}
	/*块1*/
	.block_1{
		padding: 100px 90px 70px 90px;
		width: 1140px;
		margin: 0 auto;
		.txt{
			padding-bottom: 30px;
			font-size: 18px;
		}
	}
	/*banner*/
	.banner_box{
		width: 100%;
		position: relative;
		.msg_box{
			position: absolute;
			top: 50%;
			left: 50%;
			width: 1140px;
			z-index: 1;
			transform: translate(-50%, -50%);
			color: #000000;
			text-align: center;
			.txt{
				font-size: 26px;
			}
			.tit{
				font-size: 65px;
			}
		}
		.bg{
			width: 100%;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: transparent;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		background-color: #f5f8fa;
		img{
			transform: translateX(6px);
		}
	}
}
</style>
<style scoped>
>>> .page_box .el-pager li:hover, >>> .page_box .el-pager li.active{
	color: #0B318F;
}
>>> .page_box .el-pager li{
	font-size: 15px;
}
</style>
